if (!customElements.get('pfd-search-dialog')) {
  customElements.define('pfd-search-dialog', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.input = this.querySelector('input[name="q"]');
      this.results = this.querySelector('[data-search-results]');
      this.start = this.querySelector('[data-search-start]');
      this.message = this.querySelector('[data-search-message]');
      this.clear = this.querySelector('[data-search-clear]');
      this.trigger = [...document.querySelectorAll('[data-pfd-search]')].find(link => link.dataset.pfdSearch === this.id);
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.trigger?.addEventListener('click', event => {
        event.preventDefault();
        this.trigger.closest('pfd-header')?.closePanels();
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('pfd-search-open');
        this.input.focus();
        this.onInput();
      }, options);
      this.input.addEventListener('input', () => this.onInput(), options);
      this.input.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' && !this.results.hidden) {
          const first = this.results.querySelector('a');
          if (first) { event.preventDefault(); first.focus(); }
        }
      }, options);
      this.querySelector('form').addEventListener('submit', event => {
        if (!this.input.value.trim()) { event.preventDefault(); this.input.focus(); }
      }, options);
      this.addEventListener('click', event => {
        if (event.target.closest('[data-search-close]')) this.dialog.close();
        if (event.target.closest('[data-search-clear]')) {
          this.input.value = '';
          this.onInput();
          this.input.focus();
        }
        const queryLink = event.target.closest('[data-search-query]');
        if (queryLink) {
          event.preventDefault();
          this.input.value = queryLink.dataset.searchQuery;
          this.input.focus();
          this.onInput();
        }
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.cancelSearch();
        document.body.classList.remove('pfd-search-open');
        this.trigger?.setAttribute('aria-expanded', 'false');
        this.trigger?.focus();
      }, options);
    }

    disconnectedCallback() {
      this.cancelSearch();
      this.events?.abort();
      if (this.dialog?.open) this.dialog.close();
      document.body.classList.remove('pfd-search-open');
    }

    cancelSearch() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.sequence = (this.sequence || 0) + 1;
      this.results?.setAttribute('aria-busy', 'false');
    }

    onInput() {
      this.cancelSearch();
      const query = this.input.value.trim();
      this.clear.hidden = !query;
      this.results.hidden = true;
      this.results.replaceChildren();
      this.start.hidden = query.length >= 2;
      this.message.textContent = query.length === 1 ? 'Type at least two characters for suggestions, or press Enter to search.' : '';
      if (query.length < 2) return;
      const sequence = this.sequence;
      this.timer = setTimeout(() => this.search(query, sequence), 250);
    }

    async search(query, sequence) {
      this.request = new AbortController();
      this.message.textContent = 'Finding matches…';
      this.results.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(this.dataset.suggestUrl, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product,page,article');
        url.searchParams.set('resources[limit]', '4');
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('section_id', 'pfd-predictive-search');
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (sequence !== this.sequence || !this.dialog.open) return;
        const content = new DOMParser().parseFromString(html, 'text/html').querySelector('.pfd-search-results-content');
        if (!content) throw new Error('Search unavailable');
        this.results.replaceChildren(content);
        this.results.hidden = false;
        const count = Number(content.dataset.resultCount);
        this.message.textContent = count ? `${count} suggestions available. Press Tab to explore the results.` : 'No suggestions found. Try another search or view all results.';
      } catch (error) {
        if (error.name === 'AbortError' || sequence !== this.sequence || !this.dialog.open) return;
        this.message.textContent = 'Suggestions are temporarily unavailable. Press Enter or use the search button to see all results.';
        this.start.hidden = false;
      } finally {
        if (sequence === this.sequence) this.results.setAttribute('aria-busy', 'false');
      }
    }
  });
}
